import React, {useEffect} from 'react';
import Form2 from './Form2';

function App(props) {

  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var error = props.error;
  var userNos = props.userNos;
  var addToExtraScreen = props.addToExtraScreen;
  var questions = props.questions;
  var source = props.source;
  var originalVariables = currentList[source];
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;

  useEffect(()=>{
    if (!originalVariables){
      organicChanges([{t:'w',w:[source],n:{}}])
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!originalVariables){
    return <div></div>
  }
//
//
  return <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questions} header={[]} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>
}



export default App;
